import React from 'react';
import styled from 'styled-components';
import Icon from '../IconBase';

function ProfileIcon({ width, height, ...props }: any) {
  const size = width || height || 20;

  return (

    <Icon data-icon={'profile'} fill='none' viewBox='0 0 22 22'
      width={size} height={size} {...props}>
      <g id='ProfileIcon' stroke='currentColor' strokeLinecap='round'
        strokeLinejoin='round' strokeWidth='2' transform='translate(1.000000, 1.000000)'>
        <rect id='Rectangle' x='0' y='0'
          width='20' height='16' rx='3' />
        <circle id='Oval' fill='currentColor' cx='5.5'
          cy='7.5' r='2.2' />
        <line fill='currentColor' x1='10.5' y1='9'
          x2='16.5' y2='8.25' id='Line-8-Copy'
          transform='translate(6.750000, 8.250000) rotate(8.130102)  translate(-6.750000, -8.250000) ' />
        <line fill='currentColor' x1='10.5' y1='6.50'
          x2='14.5' y2='6.50' id='Line-8' />
      </g>
    </Icon>
  );
}

export default styled(ProfileIcon)``;
